var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgModeLanguage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Type=Language"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Background",
    d: "M0 40C0 17.9088 17.9088 0 40 0C62.0912 0 80 17.9088 80 40C80 62.0912 62.0912 80 40 80C17.9088 80 0 62.0912 0 40Z",
    fill: "url(#paint0_linear_2850_55)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "paper",
    d: "M16.9695 61.8119H52.6551V19.3749H16.9695V61.8119Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "lines",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.5417 27.4967H22.1101V25.3063H37.5417V27.4967ZM22.1102 44.5005H37.5419V42.3101H22.1102V44.5005ZM37.5419 50.0365H22.1102V47.8462H37.5419V50.0365ZM37.5419 55.5727H22.1102V53.3823H37.5419V55.5727ZM22.1102 38.9644H37.5419V36.774H22.1102V38.9644ZM37.5419 33.0329H22.1102V30.8425H37.5419V33.0329Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "paper_magnified",
    d: "M54.5659 28.0057V53.2316C47.9593 58.4976 38.3097 57.7646 32.5807 51.4087C26.625 44.7972 27.1507 34.6123 33.7622 28.6567C39.6985 23.3087 48.5187 23.1929 54.5659 28.0057Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "mg_handle2",
    d: "M52.5587 54.1273L57.3353 49.8234L61.9701 54.9674L57.1935 59.2714L52.5587 54.1273Z",
    fill: "#0D5F6A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "mg_handle1",
    d: "M72.4057 63.4611C70.2418 66.421 67.9808 68.7657 65.3141 70.9696L55.3269 59.8877L62.9897 52.9869L72.4057 63.4611Z",
    fill: "#054B51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "magnifierfill",
    d: "M44.5496 26.1114C41.0838 26.1114 37.6069 27.3411 34.8349 29.8386C31.9531 32.4354 30.2546 35.9987 30.0531 39.873C29.8515 43.7473 31.1704 47.4683 33.7673 50.3501C36.3641 53.232 39.9279 54.9304 43.8017 55.132C47.677 55.3331 51.3969 54.0146 54.2788 51.4178C57.1607 48.8209 58.8591 45.2572 59.0607 41.3834C59.2623 37.5091 57.9433 33.7881 55.3465 30.9063C52.4834 27.7283 48.5238 26.1114 44.5496 26.1114Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "mg_bezel",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.6318 58.2938C43.9467 58.3102 44.2602 58.3184 44.5732 58.3184C48.9519 58.3184 53.1199 56.7212 56.3976 53.768C59.9093 50.604 61.9781 46.2619 62.2241 41.5413C62.47 36.8211 60.8627 32.2876 57.6987 28.776C51.1668 21.5274 39.9557 20.9434 32.7062 27.4749C29.1946 30.6388 27.1258 34.9814 26.8798 39.7016C26.6344 44.4222 28.2412 48.9557 31.4056 52.4674C34.5696 55.9786 38.9117 58.0478 43.6318 58.2938ZM34.8349 29.8386C37.6069 27.3411 41.0838 26.1114 44.5496 26.1114C48.5238 26.1114 52.4834 27.7283 55.3465 30.9063C57.9433 33.7881 59.2623 37.5091 59.0607 41.3834C58.8591 45.2572 57.1607 48.8209 54.2788 51.4178C51.3969 54.0146 47.677 55.3331 43.8017 55.132C39.9279 54.9304 36.3641 53.232 33.7673 50.3501C31.1704 47.4683 29.8515 43.7473 30.0531 39.873C30.2546 35.9987 31.9531 32.4354 34.8349 29.8386Z",
    fill: "#0D5F6A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "a_upper",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.7149 41.1802L41.8549 43.7833H43.2312L39.3386 35.1922H38.6441L34.764 43.7833H36.1278L37.2683 41.1802H40.7149ZM37.7765 40.0138L38.9909 37.263L40.1932 40.0138H37.7765Z",
    fill: "#FCB913"
  }), /*#__PURE__*/React.createElement("path", {
    id: "a_lower",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.3151 43.9106V38.146H48.0753V38.716C47.7035 38.212 47.0418 37.9603 46.0918 37.9603C45.3892 37.9603 44.7758 38.2554 44.2511 38.8462C43.726 39.4369 43.4636 40.1545 43.4636 40.997C43.4636 41.8317 43.7279 42.5449 44.2569 43.1357C44.7859 43.7264 45.3979 44.022 46.0918 44.022C47.009 44.022 47.6702 43.7698 48.0753 43.2659V43.9106H49.3151ZM45.168 39.7203C45.4944 39.365 45.8969 39.1871 46.3761 39.1871C46.8722 39.1871 47.2791 39.3626 47.5968 39.7141C47.915 40.065 48.0741 40.4931 48.0741 40.9964C48.0741 41.5007 47.915 41.9283 47.5968 42.2792C47.2791 42.6302 46.8722 42.8057 46.3761 42.8057C45.8969 42.8057 45.4944 42.6288 45.168 42.2735C44.8417 41.9182 44.6782 41.492 44.6782 40.9964C44.6782 40.5008 44.8417 40.0756 45.168 39.7203Z",
    fill: "#FCB913"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2850_55",
    x1: 57.4074,
    y1: 2.22222,
    x2: 18.1481,
    y2: 77.7778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2DCADE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#047583"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModeLanguage);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default MemoForwardRef;